import { FC } from 'react';

import { usePartnerOperations } from '../context/PartnerOperationsContext';
import { PartnerDividendsProvider } from '../../PartnerDividends/context/PartnerDividendsContext';
import PartnerDividends from '../../PartnerDividends';

const DividendsSectionBody: FC = () => {
  const { data } = usePartnerOperations();

  return (
    data.partner && (
      <div className="nk-block nk-block-lg">
        <PartnerDividendsProvider partner={data.partner} showTitle={false}>
          <PartnerDividends />
        </PartnerDividendsProvider>
      </div>
    )
  );
};

export default DividendsSectionBody;
